<template>
  <div>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               :on-sort-change="sortChange"
               :onSelectChange="selectChange"
               tableApi="admin/my_company/cardLists"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="user_mobile">
          <Input type="text" v-model="searchData.user_mobile" placeholder="手机号" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="user_name">
          <Input type="text" v-model="searchData.user_name" placeholder="姓名" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="car_number">
          <Input type="text" v-model="searchData.car_number" placeholder="车牌号" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="balance">
          <Input type="text" v-model="searchData.balance" placeholder="余额小于" class="lx-search-item"></Input>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="edit(0)">添加</Button>
        </FormItem>
        <FormItem>
          <Upload :action="apiPath + 'admin/my_company/importCard'"
                  name="file"
                  :headers="uploadHeader"
                  :on-success="uploadSuccess"
                  :format="['xlsx']"
                  :show-upload-list="false"
                  :on-format-error="errorFormat"
                  :max-size="2048"
          >
            <Button icon="ios-cloud-upload-outline" type="primary">批量导入</Button>
          </Upload>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="exportFile">下载模板</Button>
          <Button type="error" @click="clearBalance">批量清空余额</Button>
        </FormItem>
      </template>

    </pageTable>

    <Modal
          v-model="rechargeModal"
          :title="rechargeModalTitle"
          :loading="loadingRechargeModal"
          @on-ok="doRecharge"
          @on-cancel="cancelRechargeModal">
    <Form ref="rechargeForm" :label-width="100" :model="rechargeForm">
      <FormItem :label="'充值'+(pay_type==='litre' ? '升数' : '金额')" prop="amount">
        <Input v-model="rechargeForm.amount" placeholder="请输入整数,负数则扣除" maxlength="100"></Input>
      </FormItem>
      <FormItem label="当前公里数" prop="mile">
        <Input v-model="rechargeForm.mile" placeholder="扣减可不填，用于计算油耗" maxlength="100"></Input>
      </FormItem>
      <FormItem label="备注" prop="remark">
        <Input v-model="rechargeForm.remark" placeholder="" maxlength="50"></Input>
      </FormItem>
    </Form>
  </Modal>

    <editForm v-if="showEditForm"
              :show-edit="showEditForm"
              :card-id="editCardId"
              ref="Edit"
              @cancel-edit="cancelEdit"
              @edit-success="editSuccess"
    >
    </editForm>

    <Drawer title="油耗记录" width="800"
            :value="fuelEconomyOrder.isShow"
            :mask-closable="true"
            @on-close="fuelEconomyOrder.isShow=false">
      <cardOrder v-if="fuelEconomyOrder.isShow" :card_id="fuelEconomyOrder.card_id"></cardOrder>
    </Drawer>


    <Drawer title="车队卡流水记录" width="800"
            :value="showCardSnDrawer"
            :mask-closable="true"
            @on-close="closeCardSn">
        <cardSn :card-id="snCardId" v-if="showCardSnDrawer"></cardSn>
    </Drawer>


    <Modal
            v-model="changeLeaderModal"
            title="切换车队长"
            :loading="loadingLeaderModal"
            @on-ok="doChangeLeader"
            @on-cancel="cancelLeaderModal">
      <Form ref="leaderForm" :label-width="100" :model="leaderForm">
        <FormItem label="车队长" prop="amount">
          <Select v-model="leaderForm.leader_id">
            <Option v-for="item in leaders" :value="item.leader_id" :key="item.leader_id">{{item.leader_name}} {{item.leader_mobile}}</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>

    <Modal
            v-model="changeMobileModal"
            :title="changeMobileModalTitle"
            :loading="loadingMobileModal"
            @on-ok="doChangeMobile"
            @on-cancel="cancelMobileModal">
      <Form ref="leaderForm" :label-width="100" :model="changeMobileForm">
        <FormItem label="姓名" prop="user_name">
          <Input v-model="changeMobileForm.user_name" placeholder=""></Input>
        </FormItem>
        <FormItem label="手机号" prop="user_mobile">
          <Input v-model="changeMobileForm.user_mobile" placeholder=""></Input>
        </FormItem>
      </Form>
    </Modal>


    <Modal
            v-model="resetPwdModal.isShow"
            :title="resetPwdModal.title"
            :loading="resetPwdModal.isLoading"
            @on-ok="doResetPwd"
            @on-cancel="resetPwdModal.isShow=false">
      <Form ref="leaderForm" :label-width="100" :model="resetPwdModal">
        <FormItem label="密码" prop="card_pwd">
          <Input v-model="resetPwdModal.card_pwd" placeholder=""></Input>
        </FormItem>
      </Form>
    </Modal>

    <Modal
            v-model="qrcode.isShow"
            @on-cancel="qrcode.isShow=false">
      <img :src="'data:image/png;base64,' + qrcode.imageBase64" v-show="qrcode.imageBase64">
    </Modal>

    <cardEditBase v-if="editBaseData.isShow"
                  :show-edit="editBaseData.isShow"
                  :card-id="editBaseData.card_id"
                  ref="EditBase"
                  @cancel-edit="editBaseData.isShow = false"
                  @edit-success="editBaseData.isShow = false"
    >
    </cardEditBase>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import editForm from "./cardEdit";
  import cardSn from "./cardSn";
  import config from '@/config/base-config'
  import cardEdit from "./cardEdit";
  import cardEditBase from "./cardEditBase";
  import cardOrder from "./cardOrder";
  export default {
    name: "card",
    components:{pageTable,editForm,cardSn,cardOrder,cardEditBase},
    data() {
      return {
        apiPath:config.API_PATH,
        uploadHeader:{token:sessionStorage.getItem('token')},
        showEditForm:false,
        editCardId:0,
        companys: [],
        searchData: {
          user_mobile: '',
          balance:'',
          user_name:'',
          car_number:'',
          sort_key:'',
          sort_type:'',
        },
        selectedID:[],
        qrcode:{
          isShow:false,
          imageBase64:'',
        },
        tableColumn: [
          {title: '',type:'selection',width:60},
          {title: '车队',key: 'company_name',align: "center"},
          {title: '车牌号',key: 'car_number',align: "center"},
          {title: '姓名',key: 'user_name',align: "center"},
          {title: '手机号',key: 'user_mobile',align: "center",render:(h,params)=>{
              return h('a',{
                on:{click:()=> {this.showMobileModal(params.row)}}
              },params.row.user_mobile)
            }},
          {title: 'OBD',key: 'device_id',align: "center",render:(h,params)=>{
              if (params.row.$isEditDevice){
                return h('Input',{
                  props:{value:params.row.device_id,size:'small',autofocus: true,},
                  on:{
                    input:(val)=>{
                      this.$set(params.row,'device_id',val)
                    },
                    'on-keydown':(e)=>{
                      if (e.keyCode === 13){
                        this.setObdDevice(params.row)
                        this.$set(params.row,'$isEditDevice',false)
                      }
                    },
                    /*'on-change':(e)=>{
                      this.$set(params.row,'balance',e.target.value)
                    },*/
                    'on-blur':()=>{
                      this.setObdDevice(params.row)
                      this.$set(params.row,'$isEditDevice',false)
                      // this.$set(params.row,'$isEdit',false)
                    }
                  }
                })
              }else{
                return h('a',{
                  on:{
                    click:()=>{
                      this.$set(params.row,'$isEditDevice',true)
                    }
                  }
                },params.row.device_id)
              }
            }},
          {title: '车队长',key: 'leader_name',align: "center",render:(h,params)=>{
              return h('a',{
                on:{click:()=> {this.showLeaderModal(params.row)}}
              },params.row.leader_name)
            }},
          {title: '可加油量',key: 'balance',sortable:'custom',align: "center",render:(h,params)=>{
            if (params.row.$isEdit){
              return h('Input',{
                props:{
                  value:params.row.balance,
                  type: "number",
                  autofocus: true,
                },
                on:{
                  'on-keydown':(e)=>{
                    if (e.keyCode === 13){
                      this.rechargeCard(params.row)
                    }
                  },
                  'on-change':(e)=>{
                    this.$set(params.row,'balance',e.target.value)
                  },
                  'on-blur':()=>{
                    this.$set(params.row,'$isEdit',false)
                  }
                }
              })

            }
            else{
                return h('div',[
                  h('a',{
                    on:{
                      click:()=>{
                        // this.$set(params.row,'$isEdit',true)
                        this.showRecharge(params.row)
                      }
                    }
                  },params.row.balance),
                  h('Button',{
                    props: {type: 'primary', size: 'small'},
                    style:{marginLeft:'2px'},
                    on: {
                      click: () => {
                        this.showRecharge(params.row)

                      }
                    }
                  }, '充值')
               ])

              }
            }},
          {title: '是否限量',key: 'card_type_name',width:100,align: "center",render:(h,params)=>{
              return h('i-switch',{
                props:{
                  size:'large',
                  'true-color':'#13ce66',
                  'false-color':"#ff4949",
                  value:params.row.card_type_name === '不限量',
                },
                scopedSlots:{
                  open:()=>h('span','不限量'),
                  close:()=>h('span','限量')
                },
                on:{
                  'on-change':(e)=>{
                    this.setIsLimit(params.row,e)
                  }
                }
              })
            }},
          {title: '状态',key: 'status_name',align: "center",render:(h,params)=>{
              return h('span',params.row.status_name)
            /*if (params.row.status === 1){
              return h('Button',{
                props: {type: 'primary', size: 'small'},
                style:{marginLeft:'5px'},
                on: {click: () => {this.showCardQrcode(params.row.card_id)}}
              },'二维码')
            }else{
              return h('span',params.row.status_name)
            }*/
            }},
          {title: '油耗',key: 'fuel_economy',align: "center",render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.showFuelEconomyOrder(params.row)
                  }
                }
              },params.row.fuel_economy)

            }},
          {title: '开卡时间',key: 'create_time',width:180,align: "center"},
          {title: '操作',align: "center",width:190,render:(h,params)=>{
              return h('div',[
                h('Button',{
                  props: {type: 'primary', size: 'small'},
                  style:{marginLeft:'2px'},
                  on: {click: () => {this.showCardSn(params.row.card_id)}}
                }, '余额记录'),
                h('Button',{
                  props: {type: 'warning', size: 'small'},
                  style:{marginLeft:'2px'},
                  on: {click: () => {this.showResetPwd(params.row)}}
                }, '重置密码'),
                h('Button',{
                  props: {type: 'warning', size: 'small'},
                  style:{marginLeft:'-12px'},
                  on: {click: () => {this.editBase(params.row.card_id)}}
                }, '车牌修改'),
                h('Button',{
                  props: {type: 'error', size: 'small'},
                  style:{marginLeft:'15px'},
                  on: {click: () => {this.del(params.row)}}
                }, '删除'),
              ])
            }},
        ],
        tableData: [],

        rechargeModal:false,
        rechargeModalTitle:'',
        loadingRechargeModal:true,
        rechargeForm:{
          card_id:0,
          amount:'',
          mile:'',
          remark:'',
          card_type:''
        },

        editModal:false,
        loadingEditModal:true,
        editForm:{
          card_id:0,
          amount:'',
          mile:'',
          remark:'',
          card_type:''
        },

        showCardSnDrawer:false,
        snCardId:0,

        changeLeaderModal:false,
        loadingLeaderModal:false,
        leaderForm:{
          card_id:0,
          leader_id:'',
        },
        leaders:[],
        pay_type:'litre',
        //里程
        fuelEconomyOrder:{
          isShow:false,
          card_id:0
        },

        changeMobileModal:false,
        changeMobileModalTitle:'修改信息:',
        loadingMobileModal:false,
        changeMobileForm:{
          card_id:0,
          user_name:'',
          user_mobile:'',
        },
        resetPwdModal:{
          isShow:false,
          title:'修改密码',
          card_id:0,
          isLoading:false,
          card_pwd:''
        },
        editBaseData:{
          isShow:false,
          card_id:0,
        }
      }
    },
    methods: {
      cancelEdit(){
        this.showEditForm = false
        this.editCardId = 0
      },
      editSuccess(){
        this.$refs.table.getLists();
        this.showEditForm = false
        this.editCardId = 0
      },
      edit(card_id){
        this.showEditForm = true
        this.editCardId = card_id
      },
      editBase(card_id){
        this.editBaseData.isShow = true
        this.editBaseData.card_id = card_id
      },
      sortChange(column){
        this.searchData.sort_key=column.key
        this.searchData.sort_type=column.order
        this.$refs.table.changePage(1)
      },
      selectChange(params){
        let ids = params.map(item => item.card_id);
        this.selectedID = ids
        console.log(this.selectedID)
      },
      showRecharge(info){
        this.rechargeModal = true
        this.rechargeModalTitle = info.user_mobile + ' 车队卡充值'
        this.rechargeForm.card_id = info.card_id
      },
      cancelRechargeModal(){
        this.rechargeModal = false
        this.rechargeForm.card_id = 0
      },
      async  clearBalance(){
        if (this.selectedID.length<=0) return this.$commonFun.errorTip('请选择')
        let res = await this.$commonFun.postProxy('admin/my_company/clearBalance',{ids:this.selectedID});
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.selectedID=[]
            this.$refs.table.getLists();
          })
        })
      },
      async doRecharge(){
        if (this.rechargeForm.company_id<=0 || this.rechargeForm.amount==0){
          return this.$commonFun.errorTip('请输入正确的金额')
        }
        let res = await this.$commonFun.postProxy('admin/my_company/dealCardBalance',this.rechargeForm);
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.rechargeModal = false
            this.rechargeForm.card_id = 0
            this.$refs.table.getLists();
          })
        })
      },
      async setObdDevice(info){
        let res = await this.$commonFun.postProxy('admin/my_company/setObdDevice',{card_id:info.card_id,device_id:info.device_id});
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg)
        })
      },
      async rechargeCard(info){
        let params = {
          card_id:info.card_id,
          amount:info.balance,
        }
        let res = await this.$commonFun.postProxy('admin/my_company/dealCardBalance',params);
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.rechargeModal = false
            this.rechargeForm.card_id = 0
            this.$refs.table.getLists();
          })
        })
      },
      async doChangeLeader(){
        this.loadingLeaderModal = true;
        let res = await this.$commonFun.postProxy('admin/my_company/changeLeader',this.leaderForm);
        this.$commonFun.dealApiResult(res,()=>{
          this.cancelLeaderModal()
          this.$commonFun.successTip(res.msg)
        })
      },
      showLeaderModal(info){
        this.changeLeaderModal=true;
        this.leaderForm.leader_id = info.leader_id;
        this.leaderForm.card_id = info.card_id;
      },
      cancelLeaderModal(){
        this.loadingLeaderModal = false;
        this.changeLeaderModal=false;
        this.leaderForm.leader_id = '';
        this.leaderForm.card_id = 0;
      },

      showCardSn(card_id){
        this.showCardSnDrawer = true
        this.snCardId = card_id
      },
      closeCardSn(){
        this.showCardSnDrawer = false
        this.snCardId = 0
      },

      async lockCard(info){
        let status = parseInt(info.status);
        this.$Modal.confirm({
          title:status=== -1 ? '解锁' : '锁定车队卡',
          content:status=== -1 ? '确定解锁吗'  : '确定要锁定吗？',
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/my_company/lockCard',{card_id:info.card_id,old_status:status});
            this.$Modal.remove()
            this.$commonFun.dealApiResult(res,()=>{
              this.$refs.table.getLists();
              this.$commonFun.successTip(res.msg,()=>{
              })
            })
          }
        })
      },

      async setIsLimit(info,isNotLimit){
        let card_type = parseInt(info.card_type);
        this.$set(info,'card_type_name',isNotLimit ? '不限量':'限量')
        this.$Modal.confirm({
          content:`确定要设置为 ${isNotLimit ? '不限量' : '限量'} 吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/my_company/setIsLimit',{card_id:info.card_id,old_type:card_type,isNotLimit});
            this.$Modal.remove()
            this.$refs.table.getLists();
            this.$commonFun.dealApiResult(res)
          },
          onCancel:()=>{
            this.$refs.table.getLists();
          }
        })
      },
      del(info){
        this.$Modal.confirm({
          title:'删除',
          content:`确定要删除司机:${info.user_mobile} 吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/my_company/delCard',{card_id:info.card_id});
            this.$Modal.remove()
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip(res.msg,()=>{
                this.$refs.table.getLists();
              })
            })
          }
        })
      },
      errorFormat(){
        this.$commonFun.errorTip('只能上传xlsx格式的文件')
      },
      uploadSuccess(res){
        this.$commonFun.dealApiResult(res,()=>{
          this.$refs.table.getLists();
          this.$commonFun.successTip(res.msg,()=>{
          })
        })
      },
      exportFile(){
        window.open(config.API_PATH+'static/车队卡导入模板.xlsx')
      },
      showFuelEconomyOrder(info){
        this.fuelEconomyOrder.isShow=true
        this.fuelEconomyOrder.card_id=info.card_id
      },

      async doChangeMobile(){
        this.loadingMobileModal = true;
        let res = await this.$commonFun.postProxy('admin/my_company/changeMobile',this.changeMobileForm);
        this.$commonFun.dealApiResult(res,()=>{
          this.canceMobileModal()
          this.$commonFun.successTip(res.msg)
        })
      },
      showMobileModal(info){
        this.changeMobileModal=true;
        this.changeMobileModalTitle='修改信息:'+info.car_number;
        this.changeMobileForm.card_id = info.card_id;
        this.changeMobileForm.user_name = info.user_name;
        this.changeMobileForm.user_mobile = info.user_mobile;
      },
      cancelMobileModal(){
        this.loadingMobileModal = false;
        this.changeMobileModal=false;
        this.changeMobileForm.card_id = 0;
      },
      showResetPwd(info){
        this.resetPwdModal.isShow=true;
        this.resetPwdModal.card_id=info.card_id;
        this.resetPwdModal.title=info.car_number + ' 密码重置';
      },
      async doResetPwd(){
        this.resetPwdModal.isLoading = true;
        let res = await this.$commonFun.postProxy('admin/my_company/resetMyCardPwd',this.resetPwdModal);
        this.$commonFun.dealApiResult(res,()=>{
          this.resetPwdModal.isLoading = false;
          this.resetPwdModal.card_id=0;
          this.$commonFun.successTip(res.msg)
        })
      },
      async showCardQrcode(card_id){
        let res = await this.$commonFun.postProxy('admin/mini_code/cardQrcode',{card_id});
        this.$commonFun.dealApiResult(res,()=>{
          this.qrcode.isShow = true
          this.qrcode.imageBase64 = res.data
          // this.draw();
        })
      }


    },
    mounted() {
      this.$commonFun.postProxy('admin/my_company/cardInitPage',{}).then(res=>{
        this.leaders = res.data.leaders
        this.pay_type = res.data.pay_type
      })
    },
  }
</script>

<style scoped>

</style>
